export default __webpack_public_path__ + "static/media/surajl.095e382c.jpg";